import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

export const GetSubSystemConfiguration = async (subSystemMetaData: any) => {
    try {
        const response = await postCall(urlConfig.SubSystemMetadata, subSystemMetaData);
        return response.data;
    } catch (error) {
        console.error('Error fetching SubSystemMetadata', error);
        throw error;
    }
};

export const CreateSubSystemConfiguration = async (createSubSystemModel: any) => {
    try {
        const response = await postCall(urlConfig.CreateSubSystem, createSubSystemModel);
        return response.data;
    } catch (error) {
        console.error('Error in CreateSubSystemConfiguration', error);
        throw error;
    }
};

export const DeleteProfileName = async (createSubSystemModel: any) => {
    try {
        const response = await postCall(urlConfig.Profilenamedelete, createSubSystemModel);
        return response.data;
    } catch (error) {
        console.error('Error in DeleteProfileName', error);
        throw error;
    }
};

export const RemoveSubsystemdata = async (removeSubSytemModel: any) => {
    try {
        const response = await postCall(urlConfig.RemoveSubsystemdata, removeSubSytemModel);
        return response.data;
    } catch (error) {
        console.error('Error in RemoveSubsystemdata', error);
        throw error;
    }
};